import type { TerraUIMessage } from '@terra/shared-dto-chat-types';

export function getInitialMessages(): TerraUIMessage[] {
  return [];
}
